import FolderItem         from "@/js/Mailboxes/Entities/FolderItem";
import MessagesFullSearch from "@/js/Mailboxes/Entities/Messages/MessagesFullSearch";

export {HouseKeeperOptions as default};

/**
* HouseKeeper Filter Entity
*
* Defines house keeper filter params
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class HouseKeeperOptions {
  /**
   * Selected Folder
   *
   * @public
   *
   * @type {FolderItem}
   *
   * @since 7.0.0
   */
  folder;

  /**
   * Folder Destination
   *
   * @public
   *
   * @type {FolderItem}
   *
   * @since 7.0.0
   */
  destination;

  /**
   * Date period
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  period = 30;

  /**
   * Defines size in mb
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  size = 1;

  /**
   * Selected Messages
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  messages = [];

  /**
   * Defines housekeeper virtual folder
   *
   * @public
   *
   * @type {String|undefined}
   *
   * @since 7.0.0
   */
  virtual_folder;

  /**
   * Defines Search Criteria
   *
   * @public
   *
   * @type {MessagesFullSearch}
   *
   * @since 7.0.0
   */
  criteria;

  /**
   * Defines house keeper action
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  action;

  /**
  * Filter type
  *
  * @public
  *
  * @type {String}
  *
  * @since 7.0.0
  */
  type = 'all';

  /**
  * Resets common options
  *
  * @public
  *
  * @since 7.0.0
  *
  * @return {void}
  */
  reset() {
    this.messages       = [];
    this.virtual_folder = undefined;
  }
}